module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/5-a0d47698bca74ff7dab2f5a98f040d20.webp";